import { Vorgang } from '../../types';

export function getWiederbeschaffungswert(vorgang: Vorgang) {
  return vorgang.bewertung?.wiederbeschaffungswert ? parseFloat(vorgang.bewertung?.wiederbeschaffungswert) : 0;
}
